

import React, { useState } from 'react'
import { createUseStyles, useTheme } from 'react-jss'

import View from './View'

const useStyles = createUseStyles(theme => ({
  root: {
    flexDirection: 'row',
    alignItems: 'flex-start',
    marginBottom: '24px'
  },
  label: {
    marginLeft: '22px',
    fontFamily: 'Montserrat',
    fontStyle: 'normal',
    fontWeight: '500',
    color: '#828282',
    fontSize: '16px',
    lineHeight: '22px'
  },
  button: {
    cursor: 'pointer'
  },
  active: {
    color: theme.colors.primary
  }
}))

function Switch (props) {
  const theme = useTheme()
  const styles = useStyles({ ...props, theme })
  const [ value, setValue ] = useState(props.checked)


  const onChange = () => {
    const newValue = !value
    setValue(newValue)
    if (props.onChange) {
      props.onChange(newValue)
    }
  }

  const labelStyle = value ? `${styles.label} ${styles.active}` : styles.label

  return (
    <View className={styles.root}>
      <View className={styles.button} onClick={onChange}>{ props.icon }</View>
      <span className={labelStyle}>{ props.label }</span>
    </View>
  )
}

export default Switch